import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';

export interface ICopomexNeighborhood {
  zipCode: string;
  neighborhood: string;
  neighborhoodType: string;
  municipality: string;
  state: string;
  city: string;
}

/** Colonias por código postal (API Copomex de CradleCode, GET /zipcodes/{cp}). */
@Injectable({ providedIn: 'root' })
export class CopomexService {

  private http = inject(HttpClient);
  private cache = new Map<string, ICopomexNeighborhood[]>();

  // region neighborhoods
  async neighborhoods(zipCode: string): Promise<ICopomexNeighborhood[] | null> {
    const cp = (zipCode || '').replace(/\D/g, '');
    if (cp.length < 4 || cp.length > 5) return null;
    const padded = cp.padStart(5, '0');
    if (this.cache.has(padded)) return this.cache.get(padded)!;
    try {
      const text = await firstValueFrom(this.http.get(`${environment.copomex.urlApi}/zipcodes/${padded}`, {
        responseType: 'text',
        headers: { 'Content-Type': 'application/json', Authorization: environment.copomex.token },
      }));
      const list: ICopomexNeighborhood[] = ApiService.parse(text)?.data?.neighborhoods ?? [];
      this.cache.set(padded, list);
      return list;
    } catch {
      return null;
    }
  }
}
